import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=1084c69e"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=1084c69e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1084c69e')) {
      api.createRecord('1084c69e', component.options)
    } else {
      api.reload('1084c69e', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=1084c69e", function () {
      api.rerender('1084c69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sidebar/Sidebar.vue"
export default component.exports